import { render } from "./ElTableDraggable.vue?vue&type=template&id=5606570c"
import script from "./ElTableDraggable.vue?vue&type=script&lang=js"
export * from "./ElTableDraggable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__